import { jsx as p } from "react/jsx-runtime";
import { forwardRef as P, useRef as a, useMemo as T, useEffect as y, createElement as u } from "react";
import { Virtuoso as O } from "react-virtuoso";
import { useMergeRefs as D } from "@chakra-ui/react";
import { useSavedListProvider as E } from "./SavedList.context.es.js";
import { getDisabledState as F } from "./SavedList.helpers.es.js";
import { SavedListCreateItem as M } from "./components/SavedListCreateItem.es.js";
import "./components/SavedListEdit.es.js";
import { SavedListItem as N } from "./components/SavedListItem.es.js";
import "../../atoms/Avatar/Avatar.es.js";
import "../../atoms/Button/Button.es.js";
import "../../atoms/Paragraph/Paragraph.es.js";
import "../Badge/Badge.es.js";
import "../../icons/index.es.js";
import { SavedListFooter as W } from "./components/SavedListFooter.es.js";
import { SavedListItemSkeleton as j } from "./components/SavedListItemSkeleton.es.js";
const $ = P(({ styles: g }, h) => {
  const {
    checkedIds: I,
    createItemOptions: i,
    disabledIds: L,
    fetchNextPage: v,
    hasNextPage: S,
    isLoading: C,
    lastListWithOrder: k,
    lists: s,
    onToggleItem: x,
    renderCreateItem: r,
    skeletonListItems: n,
    total: m
  } = E(), { index: c } = k ?? {}, d = c ? c + 1 : 0, R = a(null), o = a(null), b = D(h, o), f = T(() => {
    if (i && r) {
      const t = [...s];
      return t.splice(d, 0, i), t;
    }
    return s;
  }, [i, r, s]);
  y(() => {
    r && o.current && o.current.scrollToIndex({
      index: d,
      behavior: "smooth",
      align: "center"
    });
  }, [r, o.current]);
  const l = {};
  return m && (l.totalCount = m), /* @__PURE__ */ p(
    O,
    {
      data: C && n.length ? [...f, ...n] : f,
      endReached: S ? v : void 0,
      ref: b,
      style: { height: 300, ...g },
      itemContent: (t, e) => "isPlaceholder" in e ? /* @__PURE__ */ p(j, { marginTop: t ? 4 : 0 }) : "onSubmit" in e ? /* @__PURE__ */ u(
        M,
        {
          ...e,
          key: t,
          ref: R,
          marginTop: t ? 4 : 0
        }
      ) : /* @__PURE__ */ u(
        N,
        {
          ...e,
          isChecked: I.includes(e.id),
          isDisabled: F(e, L),
          key: e.id,
          onClick: () => x(e),
          marginTop: t ? 4 : 0
        }
      ),
      components: {
        Footer: W
      },
      ...l
    }
  );
});
export {
  $ as SavedListComponent
};
//# sourceMappingURL=SavedList.component.es.js.map
